import { defineMessage } from 'react-intl';

/** Chip tab label including “schedules” context (used when short labels are ambiguous). */
export const gipReportChipTabLongWithMatchesMessage = defineMessage({
  id: 'audit.gipReport.result.tabs.long.withMatches',
  defaultMessage: 'Schedules con matches',
});

export const gipReportChipTabLongWithoutMatchesMessage = defineMessage({
  id: 'audit.gipReport.result.tabs.long.withoutMatches',
  defaultMessage: 'Schedules sin matches',
});

export const gipReportChipTabLongToBeProcessedMessage = defineMessage({
  id: 'audit.gipReport.result.tabs.long.toBeProcessed',
  defaultMessage: 'Schedules por procesar',
});

export const gipReportChipTabLongFutureMessage = defineMessage({
  id: 'audit.gipReport.result.tabs.long.future',
  defaultMessage: 'Schedules futuros',
});

export const gipReportChipTabLongMissingMaterialsMessage = defineMessage({
  id: 'audit.gipReport.result.tabs.long.missingMaterials',
  defaultMessage: 'Schedules con materiales faltantes',
});
